/**
 * Modos de geração da criação de contestação (DC_CONTESTACAO).
 *
 * Os valores aqui são os do wire da API (form-data `modo_geracao`) — os
 * rótulos e descrições visíveis vêm do i18n
 * (`contestacao.cellParams.generationMode.<modo>` / `<modo>Description`).
 *
 * NEXT roda com o modelo mais barato (MiniMax M3); STANDARD é o modo
 * balanceado e continua sendo o default; PREMIUM é o aprofundado.
 */
export const GENERATION_MODE_NEXT = "next";
export const GENERATION_MODE_STANDARD = "standard";
export const GENERATION_MODE_PREMIUM = "premium";

/** Modo pré-selecionado quando nada foi escolhido. */
export const GENERATION_MODE_DEFAULT = GENERATION_MODE_STANDARD;

/* Ordem de exibição no seletor: rápido/econômico → balanceado → aprofundado. */
export const GENERATION_MODES = [
  GENERATION_MODE_NEXT,
  GENERATION_MODE_STANDARD,
  GENERATION_MODE_PREMIUM,
];
